import $ from 'jquery';

import {Options} from '../Config/Options.js';


const Modal = {
  openClass: 'js-modalOpen',
  closeClass: 'js-modalClose',
  bodyClass: 'is-modal',

  init() {
    this.open();
    this.close();
  },

  open() {
    $(document).on("click", "." + this.openClass, function (e) {
      let modalId = $(this).data("modal");
      $("html").addClass(this.bodyClass);
      $(modalId).addClass(Options.actOpen).parent().addClass(Options.act);
      return false;
    });
  },
  close(){
    $(document).on("click", "." + this.closeClass, function (e) {
      $("html").removeClass(this.bodyClass);
      $(this)
        .parent()
        .nextAll("." + Options.actOpen)
        .removeClass(Options.actOpen)
        .parent()
        .removeClass(Options.act);
    });
  }
}

export default Modal;